module.exports = __webpack_public_path__ + "static/media/ABNB_Report_IPOIntelligence_d.19222e09.png";